import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { addEventListener } from 'ThreeTerminal_base/base';
import { QQShare } from 'ThreeTerminal_mobile';
import { h5PageCount } from 'ThreeTerminal_utils';
import Grounds from 'ThreeTerminal_base/grounds';
import errorBoundary from '@ifeng/errorBoundary';
import Loading from './loading';
import Detail from './detail';

const Layout = ({ content: { modules, base62Id, shareTitle, shareThumbnail, introduction, devicetype } }) => {
    const [loadingShow, setLoadingShow] = useState(true);

    const [width, setWidth] = useState(window.innerWidth);
    const [height, setHeight] = useState(window.innerHeight);

    const audio = useRef();

    useEffect(() => {
        if (devicetype === 'share') {
            // 分享页统计
            h5PageCount([
                {
                    behavior: 'page',
                    type: 'topic',
                    other: {
                        id: `special_ucms_${base62Id}`,
                        url: encodeURIComponent(location.href),
                        ref: encodeURIComponent(document.referrer),
                    },
                },
            ]);
        } else if (devicetype === 'client') {
            Grounds.pageStat({
                id: `special_ucms_${base62Id}`,
                type: 'other',
                url: encodeURIComponent(location.href),
                ref: encodeURIComponent(document.referrer),
            });
        }

        let play = () => {};
        let pause = () => {};
        let ended = () => {};

        window.onload = () => {
            audio.current.pause();
            audio.current.play();

            const video = document.querySelector('video');

            play = addEventListener(video, 'play', () => {
                audio.current.pause();
            });

            pause = addEventListener(video, 'pause', () => {
                audio.current.play();
            });

            ended = addEventListener(video, 'ended', () => {
                audio.current.play();
            });
        };
        setTimeout(() => {
            setWidth(window.innerWidth);
            setHeight(window.innerHeight);
        }, 1000);

        window.onresize = () => {
            setWidth(window.innerWidth);
            setHeight(window.innerHeight);
        };

        return () => {
            play();
            pause();
            ended();
        };
    }, []);

    const qqShareCofig = {
        title: shareTitle,
        img: shareThumbnail || 'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg',
        desc: introduction || '',
        cb: () => {
            console.log('分享成功');
        },
    };

    const handleLoadingShow = () => {
        setLoadingShow(!loadingShow);
    };

    const data = modules[0].data.articleList;

    console.log(data);

    return (
        <div className={styles.layout}>
            <QQShare content={qqShareCofig} />
            <audio
                preload="auto"
                loop
                autoPlay
                ref={audio}
                src="https://p1.ifengimg.com/guilaishaonian/2019/2/music.mp3"
            />
            {loadingShow && <Loading width={width} height={height} handleLoadingShow={handleLoadingShow} />}
            <Detail width={width} height={height} loadingShow={loadingShow} content={data} />
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
